import * as React from 'react';
import type {CustomFormField} from 'src/types/crm';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import classify from 'src/utils/classify';
import {Input} from '@spaced-out/ui-design-system/lib/components/Input';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import css from './index.css';


type FormikFieldType = any;

type InputFieldPropsType = {
  field: CustomFormField;
  formikField: FormikFieldType;
  error: unknown | null | undefined;
  touched: boolean;
  isRequired: boolean;
  onChange: (arg1: string, arg2: unknown) => void;
  type?: string;
  label?: string;
  classNames?: string;
  value?: string;
  disabled?: boolean;
};

export const InputField = (props: InputFieldPropsType) => {
  const {t} = useLabelTranslation();
  const {
    field,
    type = 'text',
    formikField,
    error,
    touched,
    isRequired,
    onChange,
    classNames,
    label,
    value,
    disabled,
  } = props;
  const hasError = Boolean(error && touched);

  return (
    <div className={classify(css.inputContainer, classNames)}>
      <Input
        {...formikField}
        placeholder={t('Enter_value', 'Enter value')}
        error={hasError}
        errorText={error || ''}
        required={isRequired}
        label={label}
        type={type}
        onChange={(e) => onChange(formikField.name, e.target.value)}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export const TextAreaField = ({
  field,
  formikField,
  isRequired,
  onChange,
  touched,
  error,
  classNames,
  value,
  label,
  disabled,
}: InputFieldPropsType) => {
  const hasError = Boolean(error && touched);
  const {t} = useLabelTranslation();

  return (
    <div className={classify(css.inputTextAreaContainer, classNames)}>
      <Textarea
        {...formikField}
        placeholder={t('Enter_value', 'Enter value')}
        className={css.textareaField}
        error={hasError}
        errorText={error || ''}
        required={isRequired}
        label={label || field.questionTag}
        onChange={(e) => onChange(formikField.name, e.target.value)}
        value={value || formikField.value || ''}
        disabled={disabled}
      />
    </div>
  );
};
